export default __webpack_public_path__ + "static/media/redblock.f1517e50.webp";